export default "i1 0 2 8.00 -12\n";